/* eslint-disable @typescript-eslint/no-explicit-any */
import { useDispatch } from "react-redux";
import { setManageLossFilter, resetManageLossFilters, switchDataType } from "../index";
import { DataTypeFilter } from "../types";

export const useManageLossFilterActions = () => {
  const dispatch = useDispatch();
  const updateFilter: any = ({ key, value }: { key: string; value: any }) =>
    dispatch(setManageLossFilter({ key, value }));

  const resetFilters = () => dispatch(resetManageLossFilters());

  const changeDataType = (newDataType: DataTypeFilter) => dispatch(switchDataType(newDataType));

  return { updateFilter, resetFilters, changeDataType };
};

export const useStoreEmailFilterActions = useManageLossFilterActions;
